import styles from "./ModalHeader.module.scss";

interface Props {
  count: number;
  hasLocation: boolean;
}

const ModalHeader = ({ count, hasLocation }: Props) => (
  <div className={styles.header}>
    <div className={styles.left}>
      <p className={styles.title}>Choisissez votre restaurant</p>
      <p className={styles.sub}>
        {count} disponible{count !== 1 ? "s" : ""}
        {hasLocation ? " · trié par distance" : ""}
      </p>
    </div>
  </div>
);

export default ModalHeader;